import timezones from 'compact-timezone-list'

export default {
  functional: true,

  props: {
    withEmpty: {
      type: Boolean,
      default: false
    },

    emptyValue: {
      type: String,
      default: ''
    },

    emptyText: {
      type: String,
      default: ''
    }
  },

  render(createElement, context) {
    const options = timezones.map(tz => ({ value: tz.tzCode, text: tz.label }))

    if (context.props.withEmpty) {
      options.unshift({ value: context.props.emptyValue, text: context.props.emptyText })
    }

    const data = {
      ...context.data,
      attrs: { ...context.data.attrs, options }
    }

    return createElement('b-form-select', data, [])
  }
}
